/**
 * feature-config flag names owned by structure
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const STRUCTURE_FLAG_NAMES = {
  CLEANUP_UNUSED_PROPS: 'ff-struct-3488-cleanup-unused-props',
  LIBRARY_ORPHANED_CONTENT_RECOVERY: 'ff-library-orphaned-content-recovery',
  LIBRARIES_RESTORE_ON_ADMIN: 'ff-keep-libraries-on-admin-restores',
  LOCALIZED_LIBRARIES: 'ff-scale-496-localized-libraries',
  COMPONENT_SLOT_DEFAULTS: 'ff-dsys-4702-component-slot-defaults',
  LIBRARY_UNINSTALL_TIMEOUT_FIX: 'ff-struct-3889-library-uninstall-timeout-fix',
  COLLECTION_LIST_SETTINGS_API: 'ff-struct-3998-collection-list-settings-api',
  ALLOW_CANVAS_SCROLL_DURING_COMPONENT_CREATION:
    'ff-struct-3310-canvas-scroll-during-component-creation',
  // Narrows the source/consumer split to code libraries: a site can share a
  // library while a code library is installed, and can install a code library
  // while sharing one.
  LIBRARY_SHARE_WITH_CODE_LIBRARIES_INSTALLED:
    'ff-des-7508-share-with-libraries-installed',
  LIBRARY_TRANSACTION_HEARTBEAT_WAIT:
    'ff-des-8029-library-transaction-heartbeat-wait',
};
